import { useCallback, useEffect, useRef } from 'react';
import { useCloseModal } from './useCloseModal';

export const useModalRefs = ({
  closeModal,
  isOpen,
  closeOnOutsideClick = true,
}: {
  closeModal: () => void;
  isOpen: boolean;
  closeOnOutsideClick?: boolean;
}) => {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const closeModalRef = useRef(closeModal);
  closeModalRef.current = closeModal;

  const stableCloseModal = useCallback(() => {
    closeModalRef.current();
  }, []);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;

    dialog.addEventListener('close', stableCloseModal);

    return () => {
      dialog.removeEventListener('close', stableCloseModal);
    };
  }, [stableCloseModal]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflowY = 'hidden';
      dialogRef.current?.showModal?.();
    } else {
      document.body.style.overflowY = 'auto';
      dialogRef.current?.close?.();
    }
  }, [isOpen]);

  useCloseModal(contentRef, stableCloseModal, closeOnOutsideClick);

  return {
    dialogRef,
    contentRef,
  };
};
